import { toPlainText } from '@portabletext/react';
import { PageModuleResolver } from 'components/common/PageModuleResolver';
import { PageWrapper } from 'components/common/PageWrapper';
import { Seo } from 'components/common/Seo';
import { PromotionHeroV2 } from 'components/heros/PromotionHeroV2';
import { useRatingsOverview } from 'hooks/reviews/useRatingsOverview';
import type { PromotionPageV2 } from 'types/cms/pages/PromotionPageV2';
import { addReviewsToOverline } from 'utils/addReviewsToOverline';

interface PromoPageContentV2Props extends PromotionPageV2 {
  noindex?: boolean;
}

export function PromoPageContentV2({
  title,
  hero,
  product,
  blocks,
  seo,
  noindex = true,
}: PromoPageContentV2Props) {
  const { data: ratingsOverview } = useRatingsOverview();

  const heroOverline = addReviewsToOverline(hero.overline, ratingsOverview, {
    includeRecommendedPercentage: true,
  });

  const anchorBlock = blocks?.find(
    (block) =>
      block._type === 'timeline_productBlock' ||
      block._type === 'timeline_supplementPicker' ||
      block._type === 'timeline_skincareFormatPicker' ||
      block._type === 'productBundle' ||
      block._type === 'timeline_signupBanner',
  );

  return (
    <PageWrapper>
      <Seo
        noindex={noindex}
        seo={{
          title: seo?.title ?? title,
          description:
            seo?.description ??
            (hero.text ? toPlainText(hero.text) : undefined),
          image: seo?.image,
        }}
      />

      <PromotionHeroV2
        {...hero}
        overline={heroOverline}
        title={title}
        anchorBlock={anchorBlock}
        frontrowMDProductId={product?.frontrowMDProductId}
      />

      {blocks && <PageModuleResolver blocks={blocks} />}
    </PageWrapper>
  );
}
